module.exports = __webpack_public_path__ + "img/public/AdminIcons/manageCars.svg?5ea63168";